import { useUrlParamsValueToString, useNumberFormat, Metadata } from "@bsm/component";
import { TUserStudentScholarity } from "@bsm/graphql";
import { Link } from "react-router-dom";
import { DateScholarity } from "./DateScholarity";
import { ScholarityInlineMenu } from "./ScholarityInlineMenu";

export const ScholarityListItem = (props: Partial<TUserStudentScholarity>) => {

    const urlParams = useUrlParamsValueToString()

    return (
        <div className="flex items-center justify-between w-full pt-2 pb-4 border-default border-b">
            <div className="flex items-center gap-5">
                <div className="flex flex-col justify-start gap-y-2">
                    <div className="flex items-center gap-x-4">
                        <Link to={`${props.id}?${urlParams}`}>
                            <h3 className="font-bold text-base sm:text-lg">
                                {props?.designation}
                            </h3>
                        </Link>
                        <DateScholarity {...props} />
                    </div>
                    <Metadata
                        label={'Students count :'}
                        value={props?.students ? props?.students?.filter((student) => !student.isEnrolled)?.length.toString() : '0'}
                    />
                </div>
            </div>
            <ScholarityInlineMenu {...props} />
        </div>
    )
}
